import React, { useState } from 'react';
import { observer } from 'mobx-react';
import IconsContainer from "Utils/IconsContainer";

const MultiButton = (props) => {
    const [opened, setOpened] = useState(false);

    let buttons = props.buttons.map(item => {
        let buttonClass = '';

        if (item.disabled === true)
            buttonClass = 'disabled';

        return (
            <div onClick={item.onClick}
                className={`multi-button-item ${buttonClass}`}
                key={item.title}>
                {item.title}
            </div>
        )
    });

    return (
        <div className='multi-button'
            id={props.id}
            onMouseEnter={() => setOpened(true)}
            onMouseLeave={() => setOpened(false)}
            style={{ minWidth: props.minWidth }}
        >
            <div className='multi-button-title-content'>
                <div>
                    {props.title}
                </div>
                {IconsContainer.Get('ci-arrow-down')}
            </div>
            <div
                style={{
                    visibility: opened ? null : "hidden",
                    minWidth: props.menuButtonsMinWidth,
                    right: props.menuButtonsIsRightAlignment ? '0px' : null
                }}
                className='multi-button-buttons-container'>
                {buttons}
            </div>
        </div>
    )
};

export default observer(MultiButton);